// import Search from "./search";
import Search from "./search-v2";

export default Search;
